"use client"

import React from "react"
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion"
import { cn } from "../../lib/utils"
import { triggerHaptic } from "../../utils/hapticFeedback"

export const TiltCard = React.forwardRef(
  ({ children, className, onClick, haptic = true, tiltStrength = 8 }, ref) => {
    const mouseX = useMotionValue(0)
    const mouseY = useMotionValue(0)

    const springConfig = { damping: 15, stiffness: 150 }
    const springX = useSpring(mouseX, springConfig)
    const springY = useSpring(mouseY, springConfig)

    const rotateX = useTransform(springY, [-0.5, 0.5], [`${tiltStrength}deg`, `-${tiltStrength}deg`])
    const rotateY = useTransform(springX, [-0.5, 0.5], [`-${tiltStrength}deg`, `${tiltStrength}deg`])

    const handleMouseMove = (e) => {
      const rect = e.currentTarget.getBoundingClientRect()
      const { width, height, left, top } = rect
      mouseX.set((e.clientX - left) / width - 0.5)
      mouseY.set((e.clientY - top) / height - 0.5)
    }

    const handleMouseLeave = () => {
      mouseX.set(0)
      mouseY.set(0)
    }

    const handleClick = (e) => {
      if (haptic) triggerHaptic(8)
      onClick?.(e)
    }

    return (
      <motion.div
        ref={ref}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        onClick={handleClick}
        whileTap={{ scale: 0.98 }}
        style={{ rotateX, rotateY, transformStyle: "preserve-3d" }}
        className={cn("cursor-pointer", className)}
      >
        <div style={{ transform: "translateZ(24px)", transformStyle: "preserve-3d" }}>{children}</div>
      </motion.div>
    )
  }
)
TiltCard.displayName = "TiltCard"